import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/form/:formname/:step',
    name: 'form_with_step',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../Form.vue')
  },
  {
    path: '/form/:formname',
    name: 'form',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../Form.vue')
  },
  {
    path: '/regupload/:token',
    name: 'upload_files',
    component: () => import('../forms/Upload.vue')
  },
  {
    path: '/upload_ins_doc',
    name: 'Upload Insurance Documents',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/CertUpload.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
